import {Component, DestroyRef, effect, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatDialog} from '@angular/material/dialog';
import {KtServicesFilterService} from '../service/kt-services-filter.service';
import {KtServicesFilterModalComponent} from '../components/kt-services-filter-modal/kt-services-filter-modal.component';

@Component({
  selector: 'app-kt-services',
  templateUrl: './kt-services.component.html',
  standalone: false,
})
export class KtServicesComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly filterService = inject(KtServicesFilterService);

  constructor() {
    effect(() => {
      const open = this.filterService.toggleModal();
      if (!open) return;
      const d = this.dialog.open(KtServicesFilterModalComponent, {width: '700px'});
      d.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.filterService.toggleModal.set(false);
      });
    });
  }
}
